import { render, staticRenderFns } from "./HallFluency.vue?vue&type=template&id=bf28e188&scoped=true"
import script from "./HallFluency.vue?vue&type=script&lang=js"
export * from "./HallFluency.vue?vue&type=script&lang=js"
import style0 from "./HallFluency.vue?vue&type=style&index=0&id=bf28e188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf28e188",
  null
  
)

export default component.exports